import CMSWorkshopLiveBlock from './CMSWorkshopLiveBlock';

export default CMSWorkshopLiveBlock;
